"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentTimeVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class CurrentTimeVariable {
  constructor() {
    (0, _defineProperty2.default)(this, "settings", {});
    (0, _defineProperty2.default)(this, "type", "current-time");
    (0, _defineProperty2.default)(this, "valueType", "value");
    (0, _defineProperty2.default)(this, "currentValue", void 0);
    (0, _defineProperty2.default)(this, "ref", void 0);
    (0, _defineProperty2.default)(this, "interval", null);
    (0, _defineProperty2.default)(this, "label", "Current Time");
  }
  dependencies(params, resolver) {
    return null;
  }
  getValue(ref) {
    this.ref = ref;
    this.update();
    return null;
  }
  update() {
    this.currentValue = Math.floor(Date.now() / 1000);
    if (this.ref) {
      this.ref.value = this.currentValue;
    }
  }
  startUpdates() {
    this.stop();
    this.interval = setInterval(() => {
      this.update();
    }, 1000);
    if (this.interval.unref) {
      this.interval.unref();
    }
  }
  stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}
exports.CurrentTimeVariable = CurrentTimeVariable;
//# sourceMappingURL=CurrentTimeVariable.js.map